import * as Yup from "yup";
import React, { useCallback, useState } from "react";
import { AiTwotoneTool } from "react-icons/ai";
import { FiAlertTriangle } from "react-icons/fi";
import { Formik } from "formik";
import { IoMdArrowBack, IoMdArrowForward } from "react-icons/io";
import { MdClose } from "react-icons/md";

import { useHistory } from "react-router-dom";

import Accordion from "components/layout/Accordion";
import ContainedButton from "components/layout/form/containedButton";
import OutlinedButton from "components/layout/form/outlinedButton";
import RadioField from "components/layout/form/radioField";

import imageMedidor from "assets/images/image-medidor.jpg";
import medidor from "assets/images/medidor.png";

import theme from "styles/theme";

import { useAddNewunit } from "pages/AddNewUnit/hooks/useAddNewUnit";

import {
  ButtonsContainer,
  ContactCard,
  Contacts,
  Container,
  Error,
  FormContainer,
  Header,
  IconContact,
  ImageContainer,
  InforCardContact,
  InputsContainer,
  LinkOpenModal,
  ModalButton,
  ModalContainer,
  ModalHeader,
  ModalIcon,
  ModalImage,
  ModalImageWrap,
  ModalMedidorTitle,
  ModalStyle,
  ModalText,
  ModalTitle,
  PrimaryColumn,
  SelectorField,
  SubTitle,
} from "./styles";

const Meter = (): JSX.Element => {
  const [isSelected, setIsSelected] = useState<boolean>();
  const [step, setStep] = useState("hasGasMeter");
  const [showModalUlly, setShowModalUlly] = useState(false);
  const [showModalFuelRelease, setShowModalFuelRelease] = useState(false);
  const [showModalMedidor, setShowModalMedidor] = useState(false);

  const {
    newUnitData,
    setNewUnitData,
    setStep: setStepSolicitation,
  } = useAddNewunit();

  const history = useHistory();

  const stepData = {
    hasGasReleased: {
      title: "Sua unidade está com o gás liberado?",
      subTitle: (
        <span>
          Informe se é possível consumir gás em seu apartamento/loja (exemplo:
          fogão, chuveiro, etc.). Para isso, verifique se a{" "}
          <LinkOpenModal onClick={() => setShowModalMedidor(true)}>
            válvula de gás
          </LinkOpenModal>{" "}
          de seu medidor está aberta.
        </span>
      ),
    },
    hasGasMeter: {
      title: "Possui medidor?",
      subTitle: "Verifique o exempo a seguir",
    },
  };

  const validatorSchemaGasMeter = (): any =>
    Yup.object().shape({
      hasGasMeter: Yup.string().required("É necessário selecionar uma opção"),
    });

  const validatorSchemaGasReleased = (): any =>
    Yup.object().shape({
      hasGasReleased: Yup.string().required(
        "É necessário selecionar uma opção"
      ),
    });

  const handleSubmitGasMeter = useCallback(
    ({ hasGasMeter }): void => {
      setIsSelected(!!hasGasMeter);
      setNewUnitData({
        ...newUnitData,
        hasGasMeter: hasGasMeter === "yes",
      });
      setStep("hasGasReleased");
    },
    [newUnitData]
  );

  const handleSubmitGasReleased = useCallback((): void => {
    const { hasGasReleased } = newUnitData;
    setIsSelected(!!hasGasReleased);
    setNewUnitData({
      ...newUnitData,
      hasGasReleased,
    });
    setStepSolicitation(3);
  }, [newUnitData]);

  const handleChangeOption = (e: any): void => {
    setShowModalUlly(e.target.value === "no");
  };

  const toggleOpenModalSetting = (): void => {
    setShowModalUlly((prevState) => !prevState);
  };

  const toggleOpenModalFuelRelease = (): void => {
    setShowModalFuelRelease((prevState) => !prevState);
  };

  console.log({ newUnitData });

  return (
    <Container>
      <PrimaryColumn>
        <Header>
          <h1>{stepData[step].title}</h1>
        </Header>
        <SubTitle>{stepData[step].subTitle}</SubTitle>
        {step === "hasGasMeter" ? (
          <>
            <ImageContainer>
              <img
                src={medidor}
                alt="Exemplo de Medidor de gás"
                loading="lazy"
                aria-describedby="descimage"
              />
            </ImageContainer>
            <Formik
              initialValues={{
                hasGasMeter: newUnitData?.hasGasMeter ? "yes" : "no",
              }}
              validationSchema={validatorSchemaGasMeter}
              onSubmit={handleSubmitGasMeter}
              render={({ handleChange, handleBlur, values }) => (
                <FormContainer>
                  <InputsContainer>
                    <SelectorField>
                      <RadioField
                        id="yes"
                        name="hasGasMeter"
                        value="yes"
                        type="radio"
                        onBlur={handleBlur}
                        onChange={(e) => {
                          handleChange(e);
                          handleChangeOption(e);
                        }}
                        defaultChecked={newUnitData?.hasGasMeter === true}
                      />
                      <label htmlFor="yes">Sim</label>
                    </SelectorField>
                    <SelectorField>
                      <RadioField
                        id="no"
                        name="hasGasMeter"
                        value="no"
                        type="radio"
                        onBlur={handleBlur}
                        onChange={(e) => {
                          handleChange(e);
                          handleChangeOption(e);
                        }}
                        defaultChecked={newUnitData?.hasGasMeter === false}
                      />
                      <label htmlFor="no">Não</label>
                    </SelectorField>
                  </InputsContainer>
                  {isSelected === false && values.hasGasMeter === "" && (
                    <Error>É necessário selecionar uma opção</Error>
                  )}
                  {values.hasGasMeter === "yes" && (
                    <ButtonsContainer>
                      <ContainedButton
                        block
                        type="submit"
                        continue
                        id="Avançar"
                        width="100%"
                        TrailingIcon={IoMdArrowForward}
                        propsTrailingIcon={{
                          size: 20,
                        }}
                        disabled={isSelected === false}
                      >
                        Continuar
                      </ContainedButton>
                      <OutlinedButton
                        width="100%"
                        LeadingIcon={IoMdArrowBack}
                        propsLeadingIcon={{
                          size: 20,
                        }}
                        onClick={() => {
                          setNewUnitData({
                            ...newUnitData,
                            hasGasMeter: values.hasGasMeter === "yes",
                          });
                          setStepSolicitation(1);
                        }}
                        color={theme.colors.purple}
                      >
                        Voltar
                      </OutlinedButton>
                    </ButtonsContainer>
                  )}
                </FormContainer>
              )}
            />
          </>
        ) : (
          <Formik
            initialValues={{
              hasGasReleased: newUnitData?.hasGasReleased ? "yes" : "no",
            }}
            validationSchema={validatorSchemaGasReleased}
            onSubmit={(value) => {
              if (value.hasGasReleased === "no") {
                handleSubmitGasReleased();
                return;
              }
              toggleOpenModalFuelRelease();
            }}
            render={({ handleChange, handleBlur, values }) => (
              <FormContainer>
                <InputsContainer>
                  <SelectorField>
                    <RadioField
                      id="yes"
                      name="hasGasReleased"
                      value="yes"
                      type="radio"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      defaultChecked={newUnitData?.hasGasReleased === true}
                    />
                    <label htmlFor="yes">Sim</label>
                  </SelectorField>
                  <SelectorField>
                    <RadioField
                      id="no"
                      name="hasGasReleased"
                      value="no"
                      type="radio"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      defaultChecked={
                        newUnitData?.hasGasReleased === false ||
                        values.hasGasReleased === "no"
                      }
                    />
                    <label htmlFor="no">Não</label>
                  </SelectorField>
                </InputsContainer>
                {values.hasGasReleased === "no" && (
                  <>
                    <InforCardContact>
                      <ContactCard>
                        <IconContact>
                          <AiTwotoneTool size={52} />
                        </IconContact>
                        <Contacts>
                          <p>
                            A equipe técnica da Ultragaz irá até a sua
                            residência e/ou loja em até três dias úteis
                            (contados a partir da finalização da etapa de
                            cadastro)
                          </p>
                        </Contacts>
                      </ContactCard>
                    </InforCardContact>
                    <Accordion
                      header="Confira informações importantes  para o momento da visita da equipe técnica na sua residência e/ou loja"
                      items={[
                        {
                          title: "Responsável no local",
                          body: (
                            <p>
                              É necessária a presença de um responsável no local
                              para a liberação do acesso ao seu medidor, no dia
                              da visita.
                            </p>
                          ),
                        },
                        {
                          title: "Medidor com avarias",
                          body: (
                            <>
                              <p>
                                Ilegível, embaçado e/ou desprotegidos não
                                poderão ser ligados/religados. Para esses casos
                                será necessário a substituição para um novo
                                equipamento para que o fornecimento de gás seja
                                concluído
                              </p>
                              <p>
                                Para mais informações sobre como obter o medidor
                                converse com a Ully, a nossa assistente virtual.
                              </p>
                            </>
                          ),
                        },
                        {
                          title: "Liberação do gás",
                          body: (
                            <p>
                              Após a visita da equipe técnica, para efetuar o
                              ligue/religue do seu fornecimento de gás, o
                              medidor permanecerá fechado para garantir a sua
                              segurança. Assim que possível, verifique o
                              registro “abre e fecha”, localizado no seu
                              medidor, e libere a passagem do gás.
                            </p>
                          ),
                        },
                      ]}
                    />
                  </>
                )}
                <ButtonsContainer>
                  <ContainedButton
                    block
                    type="submit"
                    continue
                    id="Avançar"
                    width="100%"
                    TrailingIcon={IoMdArrowForward}
                    propsTrailingIcon={{
                      size: 20,
                    }}
                    onClick={() => {
                      setNewUnitData({
                        ...newUnitData,
                        hasGasReleased: values.hasGasReleased === "yes",
                      });
                    }}
                    disabled={isSelected === false}
                  >
                    Continuar
                  </ContainedButton>
                  <OutlinedButton
                    width="100%"
                    LeadingIcon={IoMdArrowBack}
                    propsLeadingIcon={{
                      size: 20,
                    }}
                    onClick={() => {
                      setNewUnitData({
                        ...newUnitData,
                        hasGasReleased: values.hasGasReleased === "yes",
                      });
                      setStep("hasGasMeter");
                    }}
                    color={theme.colors.purple}
                  >
                    Voltar
                  </OutlinedButton>
                </ButtonsContainer>
              </FormContainer>
            )}
          />
        )}
      </PrimaryColumn>
      <ModalStyle
        show={showModalUlly}
        onHide={toggleOpenModalSetting}
        centered
        backdrop="static"
      >
        <ModalHeader>
          <ModalTitle>Importante</ModalTitle>
          <MdClose size={24} onClick={toggleOpenModalSetting} />
        </ModalHeader>
        <ModalContainer>
          <ModalIcon>
            <FiAlertTriangle size={56} color="#ffc107" />
          </ModalIcon>
          <ModalText>
            <span>
              Caso você ainda não tenha o medidor instalado, não será possível
              realizar a liberação do fornecimento do gás.
            </span>
            <span>
              Para mais informações sobre como obter o medidor, converse com a
              Ully, a nossa assistente virtual. Após a instalação do medidor,
              volte para realizar seu cadastro no portal.
            </span>
          </ModalText>
          <ModalButton
            onClick={() => {
              history.push("/portal");
              toggleOpenModalSetting();
            }}
          >
            Estou ciente!
          </ModalButton>
        </ModalContainer>
      </ModalStyle>
      <ModalStyle
        show={showModalFuelRelease}
        onHide={toggleOpenModalFuelRelease}
        centered
        backdrop="static"
      >
        <ModalHeader>
          <ModalTitle>Importante</ModalTitle>
          <MdClose size={24} onClick={toggleOpenModalFuelRelease} />
        </ModalHeader>
        <ModalContainer>
          <ModalIcon>
            <FiAlertTriangle size={56} color="#ffc107" />
          </ModalIcon>
          <ModalText>
            <span>
              Ao continuar, você confirma que o fornecimento de gás já está
              ligado em sua unidade não necessita de visita técnica para
              liberação. `
            </span>
          </ModalText>
          <ModalButton
            onClick={() => {
              handleSubmitGasReleased();
              toggleOpenModalFuelRelease();
            }}
          >
            Estou ciente!
          </ModalButton>
        </ModalContainer>
      </ModalStyle>
      <ModalStyle
        show={showModalMedidor}
        onHide={() => setShowModalMedidor(false)}
        centered
        backdrop="static"
        modalImage
      >
        <ModalHeader>
          <ModalMedidorTitle>
            Registro “abre e fecha” no seu medidor
          </ModalMedidorTitle>
          <MdClose
            size={24}
            onClick={() => setShowModalMedidor(false)}
            color="#0000ff"
          />
        </ModalHeader>
        <ModalContainer>
          <ModalImageWrap>
            <ModalImage src={imageMedidor} alt="imagem de registro" />
          </ModalImageWrap>
          <ContainedButton
            block
            type="submit"
            width="100%"
            onClick={() => {
              setShowModalMedidor(false);
            }}
          >
            OK
          </ContainedButton>
        </ModalContainer>
      </ModalStyle>
    </Container>
  );
};

export default Meter;
